import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {MdContentCopy, MdCheck} from 'react-icons/md';
import SQlFormatter from '../../../components/Formatter';
import {CylinderIcon} from '../../../components/CustomDrawer/CylinderIcon';

export default function CustomDrawerGenie({query, traceId = '123'}: any) {
  const [open, setOpen] = React.useState(false);
  const [copied, setCopied] = React.useState(false);
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const handleCopyAll = () => {
    const text = Array.isArray(query) ? query.join('\n\n') : query || '';
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const DrawerList = (
    <Box
      sx={{
        width: '30vw',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto', // Add scroll if content overflows
        padding: 2,
        '&::-webkit-scrollbar': {
          width: '0.25rem',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#002f6c',
          borderRadius: '5px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#002f6c',
        },
      }}
      role='presentation'
      // onClick={toggleDrawer(false)}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <h3
          style={{
            fontWeight: 'bold',
            fontSize: '1rem',
            margin: 0,
          }}
        >
          Query :{' '}
          <span style={{fontSize: '0.75rem', fontWeight: '500'}}>
            {traceId}
          </span>
        </h3>
        <Button
          variant='contained'
          size='small'
          startIcon={copied ? <MdCheck /> : <MdContentCopy />}
          onClick={handleCopyAll}
          sx={{
            textTransform: 'none',
            fontSize: '0.75rem',
            whiteSpace: 'nowrap',
          }}
        >
          {copied ? 'Copied!' : 'Copy All'}
        </Button>
      </Box>
      {Array.isArray(query) ? (
        query?.map((q: string, index: number) => (
          <Box
            key={`${index}-${q}`}
            sx={{mb: 2}}
          >
            <h4
              style={{fontWeight: 600, fontSize: '0.85rem', margin: '0.5rem 0'}}
            >
              Query {index + 1}
            </h4>
            <SQlFormatter sqlQuery={q || ''} />
          </Box>
        ))
      ) : (
        <SQlFormatter sqlQuery={query || ''} />
      )}
    </Box>
  );

  return (
    <div
      style={{
        height: '1rem',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Button onClick={toggleDrawer(true)}>
        <CylinderIcon />
      </Button>
      <Drawer
        open={open}
        onClose={toggleDrawer(false)}
        anchor={'right'}
      >
        {DrawerList}
      </Drawer>
    </div>
  );
}
